import { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import PortalLogin from './components/PortalLogin';
import NavBar from './components/NavBar';
import PersonModal from './components/PersonModal';
import { HomePage, EmpresaPage, OrganigramaPage, DepartamentosPage, DirectorioPage } from './pages/PublicPages';
import { AdminPanel } from './pages/admin/AdminPages';
import { LoginPage } from './pages/admin/AdminPages';
import './index.css';

function AppInner() {
  const { portalOk, portalLoading, adminUser } = useAuth();
  const [page, setPage]               = useState('inicio');
  const [selectedPerson, setPerson]   = useState(null);
  const [adminMode, setAdminMode]     = useState(false);
  const [showAdminLogin, setShowAdminLogin] = useState(false);

  // 1. Cargando verificación de token
  if (portalLoading) {
    return (
      <div style={{ minHeight:'100vh', background:'#2d2d2d', display:'flex', alignItems:'center', justifyContent:'center' }}>
        <div style={{ width:24, height:24, border:'2px solid #444', borderTopColor:'#E53812', borderRadius:'50%', animation:'spin 0.7s linear infinite' }} />
      </div>
    );
  }

  // 2. Sin acceso al portal → pantalla de contraseña de empleado
  if (!portalOk) return <PortalLogin />;

  // 3. Panel admin (requiere login de admin por encima)
  if (adminMode) {
    if (!adminUser && showAdminLogin) {
      return <LoginPage onSuccess={() => setShowAdminLogin(false)} onBack={() => { setAdminMode(false); setShowAdminLogin(false); }} />;
    }
    if (!adminUser) {
      // Disparar login de admin automáticamente
      setShowAdminLogin(true);
      return null;
    }
    return <AdminPanel onExit={() => setAdminMode(false)} />;
  }

  // 4. Portal público (ya autenticado como empleado)
  return (
    <>
      <NavBar
        current={page}
        onNav={setPage}
        logoUrl="/logo.png"
        isAdmin={!!adminUser}
        onAdmin={() => {
          if (adminUser) { setAdminMode(true); }
          else { setShowAdminLogin(true); setAdminMode(true); }
        }}
      />

      {page === 'inicio'         && <HomePage onNav={setPage} />}
      {page === 'empresa'        && <EmpresaPage />}
      {page === 'organigrama'    && <OrganigramaPage onSelectPerson={setPerson} />}
      {page === 'departamentos'  && <DepartamentosPage onSelectPerson={setPerson} />}
      {page === 'directorio'     && <DirectorioPage onSelectPerson={setPerson} />}

      {selectedPerson && <PersonModal person={selectedPerson} onClose={() => setPerson(null)} />}
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}
